<template>
    <v-sheet height="100%">
        <v-row no-gutters align="center" class="fill-height">
            <v-col class="text-center mb-12">
                <h1 class="blue--text text-h3 font-weight-medium">
                {{ translations.whoops404[lang] }}
                </h1>
                <div class="mt-3">
                    The page you were looking for does not exist
                {{ translations.pageNotExists[lang] }}
                </div>
                <v-btn color="secondary" outlined class="mt-5" large :to="lang"
                    >{{ translations.getMeOuttaHere[lang] }}</v-btn
                >
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import translations from "@/utils/translations/global";
export default {
    name: "NotFound",
    mixins: [translations],

    computed: {
        lang() {
            return this.$route.params.lang;
        }
    },

    beforeCreate() {
        const lang = this.$route.path.slice(0, 4);
        if (lang !== "/el/" && lang !== "/en/" && lang !== "/it/") {
            this.$router.replace("/en" + this.$route.fullPath);
        }
    }
};
</script>
